var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPersonAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.27 1.886a4.73 4.73 0 1 1 6.69 6.69 4.73 4.73 0 0 1-6.69-6.69ZM8.615 1.5a3.73 3.73 0 1 0 0 7.462 3.73 3.73 0 0 0 0-7.462Zm3.165 12.571A7.13 7.13 0 0 0 1.5 20.394v.415h9.654a.5.5 0 1 1 0 1H1a.5.5 0 0 1-.5-.5v-.922a8.133 8.133 0 0 1 11.722-7.213.5.5 0 1 1-.442.897Zm6.143-1.725a.5.5 0 0 1 .5.5V23a.5.5 0 1 1-1 0V12.846a.5.5 0 0 1 .5-.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.346 17.923a.5.5 0 0 1 .5-.5H23a.5.5 0 0 1 0 1H12.846a.5.5 0 0 1-.5-.5Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPersonAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person-add.882da01751b6f8b47d72a8bd3e53a97b.svg";